export const unifierLoginUrl =
  process.env.REACT_APP_UNIFIER_LOGIN_URL || 'https://pms.musanada.com/unifier'
